module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Scale-f3d0e5131c9784ae423cb4ef42ba68d9.svg";